import { Clientize, CreatePromoRequest, PromoDocument, PromoListResponse, UpdatePromoRequest } from 'types';

import { api } from './api';

export type PromoListClientResponse = Clientize<PromoListResponse>;
export type PromoRow = PromoListClientResponse['promos'][number];

export const promosApi = api.injectEndpoints({
  endpoints: (build) => ({
    getPromos: build.query<PromoListClientResponse, { limit: number; offset: number }>({
      query: (params) => ({ url: '/admin/promos', params }),
      providesTags: [{ type: 'Promos', id: 'LIST' }],
    }),

    createPromo: build.mutation<Clientize<PromoDocument>, CreatePromoRequest>({
      query: (body) => ({ url: '/admin/promos', method: 'POST', body }),
      invalidatesTags: [{ type: 'Promos', id: 'LIST' }],
    }),

    updatePromo: build.mutation<Clientize<PromoDocument>, { id: string; data: UpdatePromoRequest }>({
      query: ({ id, data }) => ({ url: `/admin/promos/${id}`, method: 'PATCH', body: data }),
      invalidatesTags: [{ type: 'Promos', id: 'LIST' }],
    }),
  }),
});

export const { useGetPromosQuery, useCreatePromoMutation, useUpdatePromoMutation } = promosApi;
